<template>
  <div id="container">
    <van-pull-refresh style="padding:0 10px" v-model="refreshing" @refresh="reload">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="加载完成"
        @load="load"
      >
        <div class="card margin-tb-10" v-for="model in models" :key="model.id" @click="openModel(model)">
          <h5>编号：{{model.code}} <span class="pull-right color-describe"><small>{{model.create_time}}</small></span></h5>
          <h5>金额：{{model.datas.price}}元 <span class="pull-right color-describe"><small>{{model.wor_node_name}}</small></span></h5>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    this.reload()
  },
  data () {
    return {
      models: [],

      filter: {
      },

      loading: false,
      finished: false,
      refreshing: false,

      page: 0
    }
  },
  methods: {
    reload () {
      this.finished = false
      this.loading = true
      this.page = 0
      this.models = []
      this.load()
    },
    load () {
      this.page = this.page + 1
      let params = {page: this.page, limit: 10, wor_flow_id: 'f26acd24a98c11ec9475afeb8f0a8271', datas: 1}
      Api.post('wor.request/index', params, res => {
        this.models = this.models.concat(res.data)

        this.refreshing = false
        this.loading = false
        if (this.models.length >= res.count) this.finished = true
      })
    },
    openModel (model) {
      this.$router.push('/sal/pledge/model?id=' + model.id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sal/pledge/Models.vue